/**
 * Utilitários de segurança para proteger dados sensíveis no frontend
 */

/**
 * Mascara CPF mostrando apenas os 3 primeiros e 2 últimos dígitos
 * Exemplo: 12345678901 -> 123.***.***-01
 */
export function maskCPF(cpf: string | undefined | null): string {
  if (!cpf) return '';
  
  // Remover formatação
  const cpfClean = cpf.replace(/[.\-]/g, '');
  
  if (cpfClean.length !== 11) {
    return cpf; // Retornar original se não for CPF válido
  }
  
  // Mascarar: mostrar primeiros 3 e últimos 2 dígitos
  return `${cpfClean.substring(0, 3)}.***.***-${cpfClean.substring(9)}`;
}

/**
 * Mascara email mostrando apenas parte do nome e domínio
 * Exemplo: joao.silva@example.com -> jo***@ex***.com
 */
export function maskEmail(email: string | undefined | null): string {
  if (!email || !email.includes('@')) {
    return email || '';
  }
  
  const [local, domain] = email.split('@');
  
  if (!local || !domain) {
    return email;
  }
  
  // Mascarar parte local
  const maskedLocal = local.length <= 2 
    ? local[0] + '***' 
    : local.substring(0, 2) + '***';
  
  // Mascarar domínio
  const domainParts = domain.split('.');
  const maskedDomain = domainParts.length >= 2
    ? domainParts[0].substring(0, 2) + '***.' + domainParts.slice(1).join('.')
    : domain.substring(0, 2) + '***';
  
  return `${maskedLocal}@${maskedDomain}`;
}

/**
 * Mascara telefone mostrando apenas os primeiros e últimos dígitos
 * Exemplo: (11) 98765-4321 -> (11) 9****-4321
 */
export function maskPhone(phone: string | undefined | null): string {
  if (!phone) return '';
  
  // Remover formatação
  const phoneClean = phone.replace(/[()\s\-]/g, '');
  
  if (phoneClean.length < 8) {
    return phone;
  }
  
  // Manter DDD e últimos 4 dígitos
  if (phoneClean.length === 11) { // Celular com DDD
    return `(${phoneClean.substring(0, 2)}) ${phoneClean[2]}****-${phoneClean.substring(7)}`;
  } else if (phoneClean.length === 10) { // Fixo com DDD
    return `(${phoneClean.substring(0, 2)}) ****-${phoneClean.substring(6)}`;
  }
  
  return phone;
}
